import { render, staticRenderFns } from "./ServiceItemDrawer.vue?vue&type=template&id=fdfa2d4c"
import script from "./ServiceItemDrawer.vue?vue&type=script&lang=js"
export * from "./ServiceItemDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports